import RoutingGuideTypes from './RoutingGuideTypes';

export const routingGuideSuccess = (payload) => {
  return {
    type: RoutingGuideTypes.GET_ROUTING_GUIDE_SUCCESS,
    payload,
  };
};
export const getRoutingGuidelistClearReq = (payload) => {
  return {
    type: RoutingGuideTypes.GET_ROUTING_GUIDE_LIST_CLEAR_REQ,
    payload,
  };
};
export const getRoutingGuidelist = (payload) => {
  return {
    type: RoutingGuideTypes.GET_ROUTING_GUIDE_LIST,
    payload,
  };
};

// HB Deprecated ? (not used)
export const getSpotQuoteRoutingGuidelist = (payload) => {
  return {
    type: RoutingGuideTypes.GET_SPOT_QUOTE_ROUTING_GUIDE_LIST,
    payload,
  };
};

export const getRoutingGuidelistReset = () => {
  return { type: RoutingGuideTypes.GET_ROUTING_GUIDE_DATA_RESET };
};

export const createRoutingGuideInProgress = (payload) => {
  return { type: RoutingGuideTypes.CREATE_ROUTING_GUIDE_PROGRESS, payload };
};

export const createRoutingGuideInSuccess = (payload) => {
  return { type: RoutingGuideTypes.CREATE_ROUTING_GUIDE_SUCCESS, payload };
};

export const createRoutingGuideInClear = () => {
  return { type: RoutingGuideTypes.CREATE_ROUTING_GUIDE_CLEAR };
};

export const createRoutingGuideUserInProgress = (payload) => {
  return {
    type: RoutingGuideTypes.CREATE_ROUTING_GUIDE_USER_PROGRESS,
    payload,
  };
};

export const createRoutingGuideUserInSuccess = (payload) => {
  return { type: RoutingGuideTypes.CREATE_ROUTING_GUIDE_USER_SUCCESS, payload };
};

export const createRoutingGuideUserInClear = () => {
  return { type: RoutingGuideTypes.CREATE_ROUTING_GUIDE_USER_CLEAR };
};

export const getSpotQuoteRoutingGuideDataInSuccess = (payload) => {
  return {
    type: RoutingGuideTypes.GET_SPOT_QUOTE_ROUTING_GUIDE_SUCCESS,
    payload,
  };
};

export const deleteRoutingGuidesInProgress = (payload) => {
  return { type: RoutingGuideTypes.DELETE_ROUTINGGUIDES_PROGRESS, payload };
};

export const deleteRoutingGuidesInSuccess = (payload) => {
  return { type: RoutingGuideTypes.DELETE_ROUTINGGUIDES_SUCCESS, payload };
};

export const deleteRoutingGuidesInError = (payload) => {
  return { type: RoutingGuideTypes.DELETE_ROUTINGGUIDES_ERROR, payload };
};

export const setSelectedRoutingGuides = (payload) => {
  return { type: RoutingGuideTypes.SET_SELECTED_ROUTING_GUIDE, payload };
};

export const setTransportData = (payload) => {
  return { type: RoutingGuideTypes.SET_TRASPORT_DATA, payload };
};

export const getContentNXPRoutingGuideInProgress = () => {
  return { type: RoutingGuideTypes.GET_CONTENT_NXP_ROUTING_GUIDE };
};

export const getContentNXPRoutingGuideInSuccess = (payload) => {
  return {
    type: RoutingGuideTypes.GET_CONTENT_NXP_ROUTING_GUIDE_SUCCESS,
    payload,
  };
};

export const getContentNXPRoutingGuideInError = (payload) => {
  return {
    type: RoutingGuideTypes.GET_CONTENT_NXP_ROUTING_GUIDE_ERROR,
    payload,
  };
};

export const updateContentNXPRoutingGuideInProgress = (payload) => {
  return { type: RoutingGuideTypes.UPDATE_CONTENT_NXP_ROUTING_GUIDE, payload };
};

export const updateContentNXPRoutingGuideInSuccess = (payload) => {
  return {
    type: RoutingGuideTypes.UPDATE_CONTENT_NXP_ROUTING_GUIDE_SUCCESS,
    payload,
  };
};

export const updateContentNXPRoutingGuideInError = (payload) => {
  return {
    type: RoutingGuideTypes.UPDATE_CONTENT_NXP_ROUTING_GUIDE_ERROR,
    payload,
  };
};

export const getNXPUserSearchInProgress = (payload) => {
  return { type: RoutingGuideTypes.GET_NXP_USER_SEARCH_INPROGRESS, payload };
};

export const getNXPUserSearchInInSuccess = (payload) => {
  return { type: RoutingGuideTypes.GET_NXP_USER_SEARCH_SUCCESS, payload };
};

export const getNXPUserSearchInInFail = (payload) => {
  return { type: RoutingGuideTypes.GET_NXP_USER_SEARCH_FAIL, payload };
};

export const getNXPUserSearchResetRequest = () => {
  return { type: RoutingGuideTypes.GET_NXP_USER_SEARCH_RESET_REQUEST };
};

export const setNXPUserSelectedRecord = (payload) => {
  return { type: RoutingGuideTypes.GET_NXP_USER_SELECTED_RECORD, payload };
};

export const getNXPUserSearchInClearData = () => {
  return { type: RoutingGuideTypes.GET_NXP_USER_SEARCH_CLEAR_DATA };
};

export const deleteRoutingUserInProgress = (payload) => {
  return { type: RoutingGuideTypes.DELETE_NXP_USER, payload };
};

export const deleteRoutingUserInSuccess = (payload) => {
  return {
    type: RoutingGuideTypes.DELETE_NXP_USER_SUCCESS,
    payload,
  };
};

export const deleteRoutingUserInFail = (payload) => {
  return {
    type: RoutingGuideTypes.DELETE_NXP_USER_FAIL,
    payload,
  };
};

export const getNXPUserTypesDataHandler = (payload) => {
  return {
    type: RoutingGuideTypes.NPX_USER_TYPES_DATA,
    payload,
  };
};

export const clientCodeDataActionHandler = (payload) => {
  return {
    type: RoutingGuideTypes.CLIENT_CODE_DATA,
    payload,
  };
};

export const setRoutingGuideSearchParams = (payload) => ({
  type: RoutingGuideTypes.SET_ROUTING_GUIDE_SEARCH_PARAMS,
  payload,
});

export const resetRoutingGuideSearchParams = () => ({
  type: RoutingGuideTypes.RESET_ROUTING_GUIDE_SEARCH_PARAMS,
});

export const getFilteredGuideList = (payload) => ({
  type: RoutingGuideTypes.GET_FILTERED_GUIDE_LIST,
  payload,
});

export const setRoutingSpotFilterData = (payload) => ({
  type: RoutingGuideTypes.SET_ROUTING_SPOT_FILTERED_DATA,
  payload,
});

export const getRoutingGuideCarriersProgress = (payload) => {
  return {
    type: RoutingGuideTypes.GET_CARRIERS_ROUTING_GUIDE_PROGRESS,
    payload,
  };
};

export const getRoutingGuideCollaboratorsProgress = (payload) => {
  return {
    type: RoutingGuideTypes.GET_COLLABORATORS_ROUTING_GUIDE_PROGRESS,
    payload,
  };
};

export const getRoutingGuideCarriersSuccess = (payload) => {
  return {
    type: RoutingGuideTypes.GET_CARRIERS_ROUTING_GUIDE_SUCCESS,
    payload,
  };
};

export const getRoutingGuideCollaboratorsSuccess = (payload) => {
  return {
    type: RoutingGuideTypes.GET_COLLABORATORS_ROUTING_GUIDE_SUCCESS,
    payload,
  };
};

export const getAllUsersNameForGuidesSuccess = (payload) => {
  return {
    type: RoutingGuideTypes.GET_ALL_USERS_NAME_SUCCESS,
    payload,
  };
};

export const getAllUsersNameForGuidesProgress = (payload) => {
  return {
    type: RoutingGuideTypes.GET_ALL_USERS_NAME_PROGRESS,
    payload,
  };
};

export const getRoutingGuideCarriersError = (payload) => {
  return {
    type: RoutingGuideTypes.GET_CARRIERS_ROUTING_GUIDE_ERROR,
    payload,
  };
};

export const editRoutingGuideCarrierProgress = (payload) => {
  return {
    type: RoutingGuideTypes.EDIT_CARRIER_ROUTING_GUIDE_PROGRESS,
    payload,
  };
};

export const editRoutingGuideCollaboratorsProgress = (payload) => {
  return {
    type: RoutingGuideTypes.EDIT_COLLABORATORS_ROUTING_GUIDE_PROGRESS,
    payload,
  };
};

export const editRoutingGuideCarrierError = (payload) => {
  return {
    type: RoutingGuideTypes.EDIT_CARRIER_ROUTING_GUIDE_ERROR,
    payload,
  };
};

export const addRoutingGuideCarrierProgress = (payload) => {
  return {
    type: RoutingGuideTypes.ADD_ROUTING_GUIDE_CARRIER_PROGRESS,
    payload,
  };
};

export const addRoutingGuideCollaboratorsProgress = (payload) => {
  return {
    type: RoutingGuideTypes.ADD_ROUTING_GUIDE_COLLABORATORS_PROGRESS,
    payload,
  };
};

export const addRoutingGuideCarrierError = (payload) => {
  return {
    type: RoutingGuideTypes.ADD_ROUTING_GUIDE_CARRIER_ERROR,
    payload,
  };
};

export const deleteRoutingGuideCollaboratorProgress = (payload) => {
  return {
    type: RoutingGuideTypes.DELETE_ROUTING_GUIDE_COLLABORATOR_PROGRESS,
    payload,
  };
};

export const deleteRoutingGuideCarrierProgress = (payload) => {
  return {
    type: RoutingGuideTypes.DELETE_ROUTING_GUIDE_CARRIER_PROGRESS,
    payload,
  };
};

export const addRoutingGuideHeader = (payload) => {
  return {
    type: RoutingGuideTypes.ADD_ROUTING_GUIDE_HEADER,
    payload,
  };
};
